document.documentElement.classList.remove('no-js');
document.querySelectorAll('[data-scroll-to]').forEach((el) => {
  el.addEventListener('click', (event) => {
    const selector = el.getAttribute('data-scroll-to');
    const target = selector && document.querySelector(selector);
    if (target) { event.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
});
